"use client";

import React, { useState } from "react";
import overlay from "../../../../css/components/overlaymodal-animations.module.css";
import Button from "../../../../components/Button";
import styles from "../css/declineModal.module.css";

export default function DeclineModal({ onClose, onSubmit }) {
  const [reason, setReason] = useState("Reason: Stock is scheduled to arrive tomorrow from supplier.");

  return (
    <div className={`${overlay.modalOverlay} ${styles.topOverlay}`} onClick={onClose}>
      <div className={`${overlay.modalContent} ${styles.container} ${styles.contentVisible}`} onClick={(e) => e.stopPropagation()}>
        <button className={overlay.closeButton} onClick={onClose} aria-label="Close">×</button>
        <h2 className={styles.title}>Transfer Declined</h2>
        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          rows={4}
          className={styles.textarea}
        />
        <div className={styles.footer}>
          <Button variant="secondary" onClick={onClose}>Cancel</Button>
          <Button variant="primary" onClick={() => onSubmit?.(reason)}>Submit</Button>
        </div>
      </div>
    </div>
  );
}
